import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../lib/motion";
import { SECTORS } from "../../lib/sectors";
import { StatusLabel, TypesList } from "./SectorParts";

const sector = SECTORS[0];

const SectorResidential = () => (
    <section
        data-testid="sector-residential-section"
        className="relative bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
                <motion.figure
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="group relative overflow-hidden lg:col-span-7"
                >
                    <img
                        src={sector.image}
                        alt={sector.alt}
                        loading="eager"
                        className="aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                    <figcaption className="absolute bottom-0 left-0 bg-[#0A0F1D]/85 px-4 py-2 font-mono text-[13px] tracking-[0.22em] text-mist backdrop-blur-sm">
                        {sector.caption}
                    </figcaption>
                </motion.figure>

                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="lg:col-span-5"
                >
                    <div className="flex flex-wrap items-center gap-4">
                        <span className="font-mono text-[13px] tracking-[0.3em] text-accent">
                            {sector.n}
                        </span>
                        <StatusLabel
                            tier={sector.tier}
                            id="sector-status-residential"
                        >
                            {sector.status}
                        </StatusLabel>
                    </div>
                    <h2
                        data-testid="sector-residential-headline"
                        className="mt-6 font-display text-3xl font-semibold leading-[1.1] text-white md:text-5xl"
                    >
                        {sector.title}
                    </h2>
                    <p className="mt-6 text-[16px] leading-relaxed text-mist">
                        {sector.copy}
                    </p>
                    <TypesList
                        types={sector.types}
                        idPrefix="sector-residential"
                        className="mt-8"
                    />
                </motion.div>
            </div>
        </div>
    </section>
);

export default SectorResidential;
